import { render, staticRenderFns } from "./linkTimeLimit.vue?vue&type=template&id=71d4a833&"
import script from "./linkTimeLimit.vue?vue&type=script&lang=js&"
export * from "./linkTimeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports